import React, { useState, useRef, useEffect } from 'react';
import { country } from '../json/country';
import '../country.css';

const CountryDropdown = ({ value, onChange, name }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const dropdownRef = useRef(null);

    const BASE_FLAG_URL = "https://country-code-au6g.vercel.app/";

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
                setSearchTerm('');
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Filter countries based on search term
    const filteredCountries = country.filter(item => {
        if (!item.image) return false;
        const countryCode = item.image.replace('.svg', '').toLowerCase();
        const dialCode = item.dial_code.toLowerCase();
        const search = searchTerm.toLowerCase();
        return countryCode.includes(search) || dialCode.includes(search);
    });

    const handleSelect = (item) => {
        onChange({
            target: {
                name: name,
                value: item.dial_code
            }
        });
        setIsOpen(false);
        setSearchTerm('');
    };

    const selectedCountry = country.find(item => item.dial_code === value);

    return (
        <div className="country-dropdown-container" ref={dropdownRef}>
            <button
                type="button"
                className="country-dropdown-trigger"
                onClick={() => setIsOpen(!isOpen)}
            >
                {selectedCountry && selectedCountry.image ? (
                    <>
                        <img 
                            src={`${BASE_FLAG_URL}${selectedCountry.image}`} 
                            alt={selectedCountry.image.replace('.svg', '')}
                            className="country-flag-small"
                            onError={(e) => {
                                e.target.style.display = 'none';
                            }}
                        />
                        <span className="country-dial-code">{selectedCountry.dial_code}</span>
                    </>
                ) : (
                    <span className="country-dial-code">{value || '+91'}</span>
                )}
                <svg 
                    className={`dropdown-arrow ${isOpen ? 'rotate' : ''}`}
                    width="12" 
                    height="12" 
                    viewBox="0 0 12 12"
                >
                    <path 
                        d="M2 4l4 4 4-4" 
                        stroke="currentColor" 
                        strokeWidth="2" 
                        fill="none"
                    />
                </svg>
            </button>

            {isOpen && (
                <div className="country-dropdown-menu">
                    <div className="country-search-wrapper">
                        <input
                            type="text"
                            className="country-search-input"
                            placeholder="Search country..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            autoFocus
                        />
                    </div>
                    <div className="country-list">
                        {filteredCountries.length > 0 ? (
                            filteredCountries.map((item, index) => (
                                item.image && (
                                    <div
                                        key={index}
                                        className={`country-item ${item.dial_code === value ? 'selected' : ''}`}
                                        onClick={() => handleSelect(item)}
                                    >
                                        <img 
                                            src={`${BASE_FLAG_URL}${item.image}`} 
                                            alt={item.image.replace('.svg', '')}
                                            className="country-flag"
                                            onError={(e) => {
                                                e.target.style.display = 'none';
                                            }}
                                        />
                                        <span className="country-code">
                                            {item.image.replace('.svg', '')}
                                        </span>
                                        <span className="country-dial">
                                            {item.dial_code}
                                        </span>
                                    </div>
                                )
                            ))
                        ) : (
                            <div className="country-no-results">
                                No countries found
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default CountryDropdown;